<template>
  <login></login>
</template>
<script>
import { mapState } from "vuex";
import Login from "./Login";
const fb = require("../firebaseConfig.js");
export default {
  components: {
    Login,
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  mounted() {
    if (this.userProfile != null) this.$router.push("/dashboard");
  },
};
</script>

<style>
.body {
  background-color: #fff;
  color: #081642;
}
.title {
  color: #1e2d41;
}
.app-green {
  color: #23e087;
}
.app-button-bg {
  background-color: #00cb78 !important;
  color: white;
}
.bg {
  background-image: url("/bg.svg");
  background-size: 2;
  background-position-y: -13rem;
}
.bg-white {
  background-color: #fff;
}
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1480px;
}
@media only screen and (min-width: 1100px) {
  .navbtn {
    visibility: hidden;
  }
}
@media only screen and (max-width: 1903px) {
  .imgdis {
    display: none;
  }
}
@media only screen and (max-width: 1679px), (min-width: 1904px) {
  .imgdis1 {
    display: none;
  }
}
@media only screen and (max-width: 1365px), (min-width: 1680px) {
  .imgdis2 {
    display: none;
  }
}
@media only screen and (max-width: 1263px), (min-width: 1366px) {
  .imgdis3 {
    display: none;
  }
}
@media only screen and (min-width: 1000px), (max-width: 1262px) {
  .imggone1 {
    display: none;
  }
}
@media only screen and (max-width: 700px) {
  .imggone2 {
    display: none;
  }
}
@media only screen and (min-width: 700px) {
  .imggone3 {
    display: none;
  }
}

@media only screen and (max-width: 700px) {
  .rowsize {
    margin-top: -25rem;
  }
}
@media only screen and (max-width: 450px) {
  .rowsize1 {
    margin-top: -20rem;
  }
}
@media only screen and (max-width: 350px) {
  .rowsize2 {
    margin-top: -15rem;
  }
}
@media only screen and (max-width: 1100px) {
  .navmenu {
    display: none;
  }
}

@media only screen and (max-width: 1100px) {
  .navmenu1 {
    visibility: visible;
  }
}
@media only screen and (min-width: 1100px) {
  .navmenu2 {
    visibility: hidden;
  }
}
@media only screen and (max-width: 1100px) {
  .imgbg {
    visibility: hidden;
  }
}
@media only screen and (min-width: 1100px) {
  .imgbg1 {
    visibility: visible;
  }
}

.center2 {
  left: 81%;
  cursor: pointer;
  top: 14%;
  position: absolute;
  width: 20%;
}
.footer-bg {
  background-image: url("/footer_bg.png");
  background-size: cover;
}

@media only screen and (max-width: 900px) {
  .footer-img {
    display: absolute;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    bottom: -60px;
  }
}
@media only screen and (min-width: 900px), (max-width: 1400px) {
  .footer-img {
    display: absolute;
    margin-left: auto;
    margin-right: auto;
    width: 65%;
    bottom: -60px;
  }
}
@media only screen and (min-width: 1400px) {
  .footer-img {
    display: absolute;
    width: 65%;
    bottom: -60px;
  }
}
</style>
